import { render, staticRenderFns } from "./ThreePillarsEdit.vue?vue&type=template&id=6459bddc"
import script from "./ThreePillarsEdit.vue?vue&type=script&lang=js"
export * from "./ThreePillarsEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports